<ng-template #content>
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.invoice.sendPortalModal.title' | translate }}</h4>
      <app-tooltip text="invoiceSendPortal" />
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <div class="lna-row-32 full-width">
      <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.actualDeliveryMethod' | translate }}</p>
      <p class="field-value">{{ 'pages.viewInfoRequest.invoice.deliveryMethod.Portal' | translate }}</p>
    </div>
    @if (invoice?.informationRequestInvoiceFiles?.length) {
      <div class="lna-row-32 value-wrapper file-list mt-16">
        <label class="form-label lna">{{ 'pages.viewInfoRequest.invoice.attachmentFile' | translate }}</label>
        <app-file-upload
          [isEditMode]="false"
          [existingFiles]="invoice!.informationRequestInvoiceFiles || []"
          [type]="fileTypeInvoice"
          [associatedEntityId]="invoice!.id"
          [isSubmitting]="false"
          [showDescription]="false"
          [noPadding]="true" />
      </div>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="confirm()">
      {{ 'pages.viewInfoRequest.invoice.sendPortalModal.send' | translate }}
    </button>
    <button class="secondary" (click)="close()">
      {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
    </button>
  </div>
</ng-template>
